import { useMemo } from 'react';
import { buildSidebarTabs, DM_MESSAGE_TABS } from '../../../work-queue/tasks/taskSidebarTabs';
import { stepTo } from '../../shared/patientViewState';
import { useMessageListSummary } from './useMessageListSummary';
import { useMessagePatientView } from './useMessagePatientView';
import { useMessageViewNavigation } from './useMessageViewNavigation';

// The patient's data plus list stepping, the list's summary and the sidebar tabs that depend on it.
export function useMessagePatientScreen(patientId: string) {
    const { listParams, goToPatient, backToList } = useMessageViewNavigation();
    const view = useMessagePatientView(patientId, listParams);
    const listSummary = useMessageListSummary(listParams, view.listTotal);
    const goPrevious = useMemo(
        () => stepTo(view.previousPatientId, goToPatient),
        [view.previousPatientId, goToPatient]
    );
    const goNext = useMemo(
        () => stepTo(view.nextPatientId, goToPatient),
        [view.nextPatientId, goToPatient]
    );
    const tabs = useMemo(
        () =>
            buildSidebarTabs(patientId, DM_MESSAGE_TABS, null, {
                dmNotifications: { onNextPatient: goNext, onBackToList: backToList },
                manageMonitoring: true,
                addVirtualAppointments: true
            }),
        [patientId, goNext, backToList]
    );
    return { view, listSummary, goPrevious, goNext, backToList, tabs };
}
